<script setup lang="ts">
import type { PropertyOnCard } from '@@/shared/property/types';
import type { PropertyOnList } from '@@/shared/property/api-types';

const props = defineProps<{
  property: PropertyOnList | PropertyOnCard
}>();

const { title: propertyTitle } = usePropertyTitle(toRef(() => props.property));

const runtimeConfig = useRuntimeConfig();
// max width on responsive design (single image on small devices)
// https://sharp.pixelplumbing.com/api-input
const IMG_WIDTH = 300;
const photo = computed(() => {
  const src = props.property.photos[0];
  if (!src) return;
  return getImageResize({
    src,
    width: IMG_WIDTH,
    resizeHostname: runtimeConfig.public.img.resizeHostname,
  });
});
</script>

<template>
  <picture class="aspect-square">
    <img
      v-if="photo"
      :alt="propertyTitle"
      v-bind="photo"
      :width="IMG_WIDTH"
      :height="IMG_WIDTH"
      loading="lazy"
      class="w-full aspect-square object-cover"
    >
    <div
      v-else
      class="bg-neutral-80 w-full aspect-square flex flex-col gap-m items-center justify-center text-secondary"
    >
      <Icon
        name="iad-icon:logo-iad"
        class="size-24"
      />
      <IadTitle
        :text="$t(`property.common.no_photo`)"
        tag="p"
        variant="x-small"
      />
    </div>
  </picture>
</template>
